module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab_Topic"
  }, [_c('ul', {
    staticClass: "clearfix tabBt"
  }, [_c('li', {
    class: {
      topic_Active: _vm.topicActive == 1
    },
    on: {
      "click": function($event) {
        _vm.tabListen(1)
      }
    }
  }, [_vm._v("参考答案")]), _vm._v(" "), (_vm.listenTextModule && _vm.listenTextModule.length > 0 && _vm.listenTextModule[0].questionStem) ? _c('li', {
    class: {
      topic_Active: _vm.topicActive == 2
    },
    on: {
      "click": function($event) {
        _vm.tabListen(2)
      }
    }
  }, [_vm._v("听力原文")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "Topic_bg"
  }, [(_vm.topicActive == 1) ? _c('div', [_vm._l((_vm.infoAnswer), function(val, answerindex) {
    return (_vm.qtype == 1) ? _c('span', [_vm._v(_vm._s(_vm._f("fromCharCode")(val.index)))]) : _vm._e()
  }), _vm._v(" "), (_vm.qtype == 2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.setRefAnswer(_vm.question.options, _vm.question.ref_info))
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.infoAnswer), function(val, stemIndex) {
    return (_vm.qtype == 3) ? _c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(val.stem)
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.qtype == 6) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.infoAnswer.solving_idea)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.qtype == 7) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.infoAnswer)
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.topicActive == 2 && _vm.listenTextModule) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.listenTextModule[0].questionStem)
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-16e5c5e3","hasScoped":false}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/question/listenTabTopic.vue
// module id = 178
// module chunks = 1